"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _NewbuildingKpnBannerContext = require("./NewbuildingKpnBannerContext");
Object.keys(_NewbuildingKpnBannerContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _NewbuildingKpnBannerContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NewbuildingKpnBannerContext[key];
    }
  });
});